import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../emitter/Observer";
import { useSelector } from "react-redux";
import { SelectorCharacterUI } from "./introduction/SelectorCharacterUI";
import { useNavigate } from "react-router-dom";
import { DialogBarNew } from "../components/common/DialogBarNew";
import { ButtonPlay } from "../components/common/ButtonPlay";
import { ButtonHome } from "../components/common/ButtonHome";
import { icons } from "../assets/icons";
import { imgs } from "../assets/imgs";
import { audiosAssets } from "../assets/audio";
import { voicesTypeControl } from "../types/audioType";

const steps = {
	introduction: 1,
	dialogOne: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
};
export const Introduction = () => {
	const { loaded } = useSelector((state) => state.menu);
	const navigation = useNavigate();
	const [uiToShow, setuiToShow] = useState(-1);
	useEffect(() => {
		if (loaded) {
			console.log("mounted introduction");
			ObserverEmitter.emit(EVENTS.init_introduction);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.initIntroduction, () => {
		setuiToShow(steps.introduction)
	})
	return (
		<>
			{![steps.introduction, steps.dialogOne].includes(uiToShow) && (
				<>
					<ButtonPlay />
					<ButtonHome />
				</>
			)}
			{uiToShow === steps.introduction && (
				<>
					<div className="fixed  z-40 bg-[#00000074] w-full h-full flex justify-center items-center">
						<div className="h-full w-full relative">
							<div className="absolute top-5 left-5">
								<div className="w-12 h-12 p-3 rounded-full bg-[#00000099]">
									<img className="h-full w-full object-contain" src={icons.soundOn} alt="play" />
								</div>
							</div>
							<div className="absolute top-8 left-20">
								<div className="w-[321px] h-[176px] relative">
									<img className="h-full w-full object-contain" src={imgs.textodialog} alt="dialogo" />
									<div className="absolute w-full h-full top-0 pl-5 pr-2 pb-3 pt-4">
										<div className="h-full w-full px-6 flex flex-col gap-4">
											<div className="text-white font-bold text-[16px]">
												<p>Audio</p>
											</div>
											<div className="text-white text-[13px]">
												<p>Presiona el botón para silenciar o activar el sonido.</p>
											</div>
											<div className="px-10 pt-1">
												<button
													onClick={() => {
														ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
														setuiToShow(steps.dialogOne);
													}}
													className="boxShadowButtons bg-[#FFC427] text-white w-full py-1 rounded-xl"
												>
													Entendido
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</>
			)}
			{uiToShow === steps.dialogOne && (
				<>
					<div className="fixed  z-40 bg-[#00000074] w-full h-full flex justify-center items-center">
						<div className="h-full w-full relative">
							<div className="absolute top-5 right-5">
								<div className="w-12 h-12 p-3 rounded-full bg-[#00000099]">
									<img className="h-full w-full object-contain" src={icons.home} alt="play" />
								</div>
							</div>
							<div className="absolute top-8 right-20">
								<div className="w-[321px] h-[176px] relative">
									<img className="h-full w-full object-contain -scale-x-100" src={imgs.textodialog} alt="dialogo" />
									<div className="absolute w-full h-full top-0 pl-2 pr-4 pb-3 pt-6">
										<div className="h-full w-full px-6 flex flex-col gap-4">
											<div className="text-white font-bold text-[16px]">
												<p>Inicio</p>
											</div>
											<div className="text-white text-[13px]">
												<p>Presiona el botón para regresar al tablero inicial.</p>
											</div>
											<div className="px-10 pt-1">
												<button
													onClick={() => {
														ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
														ObserverEmitter.emit(EVENTS.init_instructions);
														setuiToShow(steps.dialogTwo);
													}}
													className="boxShadowButtons bg-[#FFC427] text-white w-full py-1 rounded-xl"
												>
													Entendido
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<SelectorCharacterUI
					callback={() => {
						setuiToShow(steps.dialogThree);
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.introduccion.int01)
						ObserverEmitter.emit(EVENTS.final_instructions);
						ObserverEmitter.emit(EVENTS.move_escritorio_introduction);
					}}
				></SelectorCharacterUI>
			)}
			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						titulo="Andati"
						dialog={
							"¡Hola! Soy Datti Andati tu compañero guía durante este curso. Yo te acompañaré en tu proceso de inducción siendo tu apoyo para resolver cualquier duda."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.introduccion.int02)
							setuiToShow(steps.dialogFour);
						}}
						percentage={"10%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						titulo="Andati"
						dialog={
							"Estaré contigo en todo momento para proporcionarte la información necesaria. Dentro de tu recorrido se presentarán actividades que te ayudarán a comprender tu función dentro de la Tienda OXXO."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.introduccion.int03)
							setuiToShow(steps.dialogFive);
						}}
						percentage={"10%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFive && (
				<>
					<DialogBarNew
						titulo="Andati"
						dialog={
							"Iremos aprendiendo y tendremos actividades a responder que te brindarán puntos. ¡Los puntos te ayudarán a conseguir insignias!"
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
							navigation("/home1/tema1/subtema1/activityone");
						}}
						percentage={"10%"}
					></DialogBarNew>
				</>
			)}
		</>
	);
};
